<template>
  <div id="get-set-up">
    <el-row>
      <el-col :span="isGeneralAdmin || hasFilter ? 12 : 24">
        <organization-breadcrumb :items="[$t($i18nLabelsHelper(currentOrganizationType, 'get_set_up.title'))]" />
      </el-col>
      <el-col v-if="isGeneralAdmin || hasFilter" :span="12">
          <admin-organization-switcher/>
      </el-col>
    </el-row>
    <div class="content">
      <h2>{{ $t($i18nLabelsHelper(currentOrganizationType, "get_set_up.title")) }}</h2>
      <p class="sub-title">{{ $t($i18nLabelsHelper(currentOrganizationType, "get_set_up.title_note")) }}</p>
      <div>
        <el-card class="box-card" shadow="never" v-for="(item, index) in getItems" :key="index">
          <div class="card-number">
            <span>{{ index + 1 }}</span>
          </div>
          <div class="card-content">
            <h2>{{ item.title }}</h2>
            <p>{{ item.description }}</p>
            <primary-button  :id="item.id" class="bigger" @click.native="item.action" v-if="item.type === 'button'">
              {{ item.button }}
            </primary-button>
            <router-link :to="item.action" v-if="item.type === 'link'">
              <primary-button :id="item.id" @click.native="handleButtons(item.id,item.button)" class="bigger">
                {{ item.button }}
              </primary-button>
            </router-link>
          </div>
        </el-card>
      </div>
    </div>
    <div class="modals">
      <invite-admin
        :dialogVisible="modals.showInviteAdminModal"
        v-on:closed="modals.showInviteAdminModal = false"
        :organizationId="organizationId"
      />
      <invite-teachers
        :dialogVisible="modals.showInviteTeacherModal"
        :organizationId="organizationId"
        :organizationType="currentOrganizationType"
        :inviteUsers="handleInviteUsers"
        v-on:closed="modals.showInviteTeacherModal = false"
      />
    </div>
  </div>
</template>

<script>
  import PrimaryButton from "@/components/common/buttons/PrimaryButton";
  import OrganizationBreadcrumb from "@/components/common/OrganizationBreadcrumb";
  import InviteAdmin from "@/components/modals/organizations/InviteAdmin";
  import InviteTeachers from "@/components/modals/organizations/InviteTeachers";
  import AdminOrganizationSwitcher from "@/components/dashboard/AdminOrganizationSwitcher";
  import { mapGetters, mapActions } from "vuex";
  import { TEACHER } from "@/constants/userRoles";

  export default {
    components: { OrganizationBreadcrumb, PrimaryButton, InviteAdmin, InviteTeachers,AdminOrganizationSwitcher },
    props: {},
    data() {
      return {
        isAllowInvite: true,
        modals: {
          showInviteAdminModal: false,
          showInviteTeacherModal: false,
        },
      };
    },
    mounted() {},
    methods: {
      handleButtons(id,button) {
        try {
          if(this.$store.state.org.currentGetsetupButtonClickCount==0) {
            this.$gtag.event( id , {
              'category': `First-Click`,
              'label': button
            });
            this.$store.dispatch("org/setGetsetupButtonClickCount", {
              getsetupButtonClickCount:1,
            });
          }
        } catch (error) { 
            const message = 'error';
        } 
      },
      handleAddAdmin() {
        this.modals.showInviteAdminModal = true;
        try {
          this.$gtag.event(`add-admin-submit`, {
            'category': `Time-Spent`,
            'label': `Add Admins`
          });
          if(this.$store.state.org.currentGetsetupButtonClickCount==0) {
            this.$gtag.event(`get-set-up-add-admin`, {
              'category': `First-Click`,
              'label': `Add Admins`
            });
            this.$store.dispatch("org/setGetsetupButtonClickCount", {
              getsetupButtonClickCount:1,
            });
          } 
        } catch (error) { 
            const message = 'error';
        }
      },
      handleAddTeacher() {
        this.modals.showInviteTeacherModal = true;
        try {
          this.$gtag.event(`add-teacher-submit`, {
            'category': `Time-Spent`,
            'label': `Invite Teachers`
          });
          if(this.$store.state.org.currentGetsetupButtonClickCount==0) {
            this.$gtag.event(`get-set-up-add-teacher`, {
              'category': `First-Click`,
              'label': `Invite Teachers`
            });
            this.$store.dispatch("org/setGetsetupButtonClickCount", {
              getsetupButtonClickCount:1,
            });
          }
        } catch (error) { 
            const message = 'error';
        }
      },
      handleInviteUsers(emails, first_names, last_names, _, consent) {
        const organizationId = this.organizationId;

        return this.inviteUsers({
          organizationId,
          emails,
          first_names,
          last_names,
          role: TEACHER,
          consent,
        });
      },
      ...mapActions("invite", ["inviteUsers"]),
    },
    computed: {
      getItems() {
        let data = [
          {
            id:'get-set-up-add-admin',
            title: this.$t(this.$i18nLabelsHelper(this.currentOrganizationType, "get_set_up.step1.title")),
            description: this.$t(this.$i18nLabelsHelper(this.currentOrganizationType, "get_set_up.step1.description")),
            button: this.$t(this.$i18nLabelsHelper(this.currentOrganizationType, "get_set_up.step1.button")),
            action: this.handleAddAdmin,
            type: "button",
          },
          {
            id:'get-set-up-add-teacher',
            title: this.$t(this.$i18nLabelsHelper(this.currentOrganizationType, "get_set_up.step2.title")),
            description: this.$t(this.$i18nLabelsHelper(this.currentOrganizationType, "get_set_up.step2.description")),
            button: this.$t(this.$i18nLabelsHelper(this.currentOrganizationType, "get_set_up.step2.button")),
            action: this.handleAddTeacher,
            type: "button",
          },
          {
            id:'get-set-up-add-team',
            title: this.$t(this.$i18nLabelsHelper(this.currentOrganizationType, "get_set_up.step3.title")),
            description: this.$t(this.$i18nLabelsHelper(this.currentOrganizationType, "get_set_up.step3.description")),
            button: this.$t(this.$i18nLabelsHelper(this.currentOrganizationType, "get_set_up.step3.button")),
            action: "/organization/" + this.organizationId + "/teams/new",
            type: "link",
          },
          {
            id:'get-set-up-add-student',
            title: this.$t(this.$i18nLabelsHelper(this.currentOrganizationType, "get_set_up.step4.title")),
            description: this.$t(this.$i18nLabelsHelper(this.currentOrganizationType, "get_set_up.step4.description")),
            button: this.$t(this.$i18nLabelsHelper(this.currentOrganizationType, "get_set_up.step4.button")),
            action: "/admin/organization/" + this.organizationId + "/students",
            type: "link",
          },
        ];
        if (this.isOrganizationAssociateAdmin) data.shift(); // remove invite admin
        return data;
      },
      organizationId() {
        return this.$store.state.organization.currentOrganizationId;
      },
      organizationData() {
        return this.$store.state.organization.currentOrganization;
      },
      ...mapGetters("organization", [
        "isOrganizationAdmin", 
        "isOrganizationAssociateAdmin", 
        "currentOrganizationType", 
        "isGeneralAdmin",
        "hasFilter",
        ]),
    },
  };
</script>

<style lang="scss" scoped>
  #get-set-up {
    width: 100%;

    .content {
      width: 60%;
      margin: auto;
      padding: 40px 16px;

      .sub-title {
        margin: 8px 0 32px 0;
      }

      .box-card {
        max-width: 830px;
        background: #ffffff;
        border: 2px solid #e1e1e1;
        box-sizing: border-box;
        border-radius: 8px;
        margin-bottom: 16px;

        ::v-deep .el-card__body {
          display: flex;
          flex: 1;
          align-items: flex-start;

          .card-number {
            margin-right: 16px;

            span {
              display: inline-block;
              vertical-align: baseline;
              background: #ffffff;
              border-radius: 50%;
              width: 40px;
              height: 40px;
              border: 1px solid #e6e6e6;
              box-sizing: border-box;
              font-weight: 600;
              font-size: 24px;
              line-height: 36px;
              text-align: center;
              color: #121131;
            }
          }

          .card-content {
            flex: 1 0;

            h2 {
              font-size: 24px;
              line-height: 36px;
              color: #121131;
            }

            p {
              font-size: 16px;
              line-height: 24px;
              color: #121131;
            }

            .bigger {
              height: 48px;
              max-width: 205px;
            }
          }
        }
      }
    }

    h2 {
      font-weight: 600;
      font-size: 32px;
      line-height: 48px;
      color: #121131;
    }

    p {
      font-size: 18px;
      line-height: 28px;
      color: #121131;
      opacity: 0.8;
    }
  }
</style>
